import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"

export function useNavigationProgress() {
  const location = useLocation()
  const [isDone, setIsDone] = useState(true)
  const [progressKey, setProgressKey] = useState(0)

  useEffect(() => {
    setIsDone(false)
    setProgressKey((k) => k + 1)

    const completeTimer = setTimeout(() => {
      setIsDone(true)
    }, 400)

    const fallbackTimer = setTimeout(() => {
      setIsDone(true)
    }, 2000)

    return () => {
      clearTimeout(completeTimer)
      clearTimeout(fallbackTimer)
    }
  }, [location.pathname, location.search])

  return { isDone, progressKey }
}
